import api from './http'

// 查询国内机票行程列表
export function seldomestic (params) {
  return api.post('/flight/domestic/getTicketNew', params, {
    headers: {
      load: false
    }
  })
}
// 国内机票改签分页查询
export function getChangeOrderPage (params) {
  return api.post('/dps/change/getChangeOrderPage', params, {
    headers: {
      load: false
    }
  })
}
// 国内机票退票分页查询
export function getRefundOrderPage (params) {
  return api.post('/dps/refund/getRefundOrderPage', params, {
    headers: {
      load: false
    }
  })
}
// 查询国内机票详情
export function getTickentDeetail (params) {
  return api.post('/flight/domestic/getTicketDetail', params)
}
// 国内机票改签信息提交
export function editChangTickDetail (params) {
  return api.post('/dps/change/applyChange', params)
}
// 获取改签费用(自愿)
export function getChangeFee (params) {
  return api.post('/dps/change/getChangeFee', params)
}
// 获取改签详情
export function changeDetail (params) {
  return api.post('/dps/change/getChangeDetailed', params)
}
// 状态字典获取
export function getDictone (params) {
  return api.post('/baseData/getDictone', params, {
    headers: {
      load: false
    }
  })
}
// 国内机票退票申请
export function refundTicket (params) {
  return api.post('/dps/refund/applyRefund', params)
}
// 获取退票费(自愿)
export function getRefundFee (params) {
  return api.post('/dps/refund/getRefundFee', params)
}
// 国内机票取消订单
export function saleCancel (params) {
  return api.post('/flight/domestic/saleCancel', params)
}
// 国内机票退票
export function returnTicket (params) {
  return api.post('/dps/refund/getRefundDetailed', params)
}
// 机票退改配置
export function dicRefundChangeSet (params) {
  return api.post('/cps/refundChange/selectRefundChange', params, {
    headers: {
      load: false
    }
  })
}
// 国际机票列表
export function getInternationalOrderlist (params) {
  return api.post('/ift/getOrderList', params, {
    headers: {
      load: false
    }
  })
}
// 国际机票改签列表
export function getIntChangelist (params) {
  return api.post('/ift/change/search', params, {
    headers: {
      load: false
    }
  })
}
// 国际机票退票列表
export function getIntRefundlist (params) {
  return api.post('/ift/Refund/search', params, {
    headers: {
      load: false
    }
  })
}
// 国际机票详情
export function internationslDetail (params) {
  return api.post('/ift/getOrderDetailed', params)
}
// 国际改签详情
export function internationChangeDetail (params) {
  return api.post('/ift/change/getChangeDetailed', params)
}
// 国际改签单号查询订单详情
export function internationChangNoOrderrDetail (params) {
  return api.post('/ift/getApplyOrderDetailed', params)
}
// 国际改签申请
export function internationApplyChange (params) {
  return api.post('/ift/change/applyChange', params)
}
// 国际机票退票申请
export function internationrefund (params) {
  return api.post('/ift/Refund/applyChange', params)
}
// 国际退票详情
export function internationRefundTicket (params) {
  return api.post('/ift/Refund/getChangeDetailed', params)
}
// ===================================================================================================
// 酒店订单列表请求
export function getHotelOrderList (params) {
  return api.post('/hotel/order/getHotelOrderList', params, {
    headers: {
      load: false
    }
  })
}

// 根据订单号请求详情
export function getOrderHotemDetail (params) {
  return api.post('/hotel/order/getHotelDetailBySaleOrderNo', params)
}
// 酒店订单详情
export function getHotemDetail (params) {
  return api.post('/hotel/order/getHotelDetail', params)
}
// 取消酒店订单
export function cancelHotelOrder (params) {
  return api.post('/hotel/order/cancelHotelOrder', params)
}
// 取消酒店原因查询
export function getCancelMessage (params) {
  return api.post('/hotel/order/getCancelMessage', params)
}
// 超额自付
export function confirmPay (params) {
  return api.post('/pay/confirmPay', params)
}
// 月结确认改签
export function confirmChange (params) {
  return api.post('/dps/change/confirmChange', params)
}
// ========================================================================================================
// 火车票订单列表
export function getTranlist (params) {
  return api.post('/train/order/getOrderList', params, {
    headers: {
      load: false
    }
  })
}
// 火车票改签订单列表查询
export function getChangeList (params) {
  return api.post('/train/order/getChangeList', params, {
    headers: {
      load: false
    }
  })
}
// 火车票订单详情
export function getTrainDetail (params) {
  return api.post('/train/order/saleInDetail', params)
}
// 火车票退票申请
export function refundTrainorder (params) {
  return api.post('/train/refundOrder', params)
}
// 火车票改签申请
export function changeSendOrder (params) {
  return api.post('/train/changeOrder', params)
}
// 火车票取消改签申请
export function cencelChangeOrder (params) {
  return api.post('/train/cancelChange', params)
}
// 火车票退改详情
export function getchangeRundefByNo (params) {
  return api.post('/train/order/saleInDetailByChangNo', params)
}
// 火车票占座成功取消订单
export function cancelOrder (params) {
  return api.post('/train/cancelOrder', params)
}
// ======================================================
// 行程单审批列表
export function seltrandeList (params) {
  return api.post('/trandeApprove/selectPageList', params, {
    headers: {
      load: false
    }
  })
}
// 火车票订单审批
export function appTrainorder (params) {
  return api.post('/train/order/approveTrainOrder', params)
}
// 火车票退票审批
export function appTrainRefund (params) {
  return api.post('/train/order/approveRefundOrder', params)
}
// 火车票改签审批
export function appTrainCahnge (params) {
  return api.post('/train/order/approveChangeOrder', params)
}
// 酒店订单审批
export function appHotelorder (params) {
  return api.post('/hotel/order/approveHotelOrder', params)
}
// 辆机票订单审批
export function appDomair (params) {
  return api.post('/flight/domestic/approveOrder', params)
}
// 国内机票改签审批
export function appDomairChange (params) {
  return api.post('/dps/change/approveOrder', params)
}
// 辆机票退票审批
export function appDomairRefund (params) {
  return api.post('/dps/refund/approveOrder', params)
}
// 国际机票订销售单审批
export function appInterAir (params) {
  return api.post('/ift/approveOrder', params)
}
// 国际机票退废审批
export function appInterRefund (params) {
  return api.post('/ift/Refund/approveOrder', params)
}
// 国际机票改签审批
export function appInterChange (params) {
  return api.post('/ift/change/approveOrder', params)
}
// =====================================================
// 因公月结确认支付
export function compay (params) {
  return api.post('/pay/comPay', params)
}
// 报表表头查询
export function getReporthead (params) {
  return api.post('/report/getReportHeader', params)
}
// 国内报表
export function getDomReportPage (params) {
  return api.post('/report/getDpsReportPage', params)
}
// 国际机票
export function getIntReportPage (params) {
  return api.post('/report/getIftReportPage', params)
}
// 酒店报表
export function getHotelReportPage (params) {
  return api.post('/report/getHolReportPage', params)
}
// 火车票
export function getTrainReportPage (params) {
  return api.post('/report/getTraReportPage', params)
}
// 报表下载
export function exportIftReport (params) {
  return api.post('POST /app/api/report/exportReport', params)
}



// WEBPACK FOOTER //
// ./src/axios/manageApi.js